import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

function CustomTooltip({ children, tooltipContent, interactive = false }) {
  return (
    <TooltipProvider disableHoverableContent={!interactive}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className="px-2 py-1 text-xs text-white bg-gray-800 rounded shadow-md">{tooltipContent}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default CustomTooltip;
